import React from 'react'
import { Grid } from '@material-ui/core'
import styles from './vulner_statistics_card.module.css'
import strings from '../../strings/strings.json'
import CircularPercentage from '../circular_percentage'


export default function VulnerStatisticsCard(props) {
    const colorHandler = () => {
        if (props.isPercent) {
            const percent = props.num
            if (percent >= 30)
                return 'text-red-600 bg-red-200'
            if (percent < 30 && percent >= 20)
                return 'text-orange-600 bg-orange-200'
            else
                return 'text-green-600 bg-green-200'
        }
    }

    const textHandler = () => {
        if (props.isPercent) {
            const percent = props.num
            if (percent >= 30)
                return strings.general_highRisk
            if (percent < 30 && percent >= 20)
                return strings.general_mediumRisk
            else
                return strings.general_lowRisk
        }
    }
    return (
        <div className={`${styles.container} flex`}>
            <div className={`px-4 flex items-center rounded-2xl ${(!props.isPercent) ? 'bg-green-100' : 'bg-red-100'}`}><img className={`${!props.isPercent ? 'h-5' : 'h-5'}`} src={`/assets/icons/${props.icon}.svg`} alt="cardIcon" /></div>
            <div className='flex flex-col mr-2'>
                <span className='secondry_color text-xs'>{props.title}</span>
                <div className='flex items-center'>
                    <span className='primary_color font-extrabold text-2xl'>{props.num}{props.isPercent&&'%'}</span>
                    {
                        props.isPercent &&
                        <div className='flex items-end'><span style={{whiteSpace:'nowrap'}} className={`rounded-2xl px-2 py-1 text-xs mr-3 ${colorHandler()}`}>{textHandler()}</span></div>
                    }
                </div>
            </div>

        </div>
    )
}

/* 
<div className={styles.vulner_card_container}>
            sqSize={40}
            percentage={props.num}
            strokeWidth={3}
            <React.Fragment>
                {
                    props.isGauge ?
                        <Grid container>
                            <Grid item md={4} xs={4}>
                                <div>
                                    <div style={{ position: "relative", paddingTop: "25px" }}>
                                        <CircularPercentage
                                        />

                                    </div>
                                </div>
                            </Grid>
                            <Grid item md={8} xs={8}>
                                <span className={styles.riskTracking_title}>{strings.general_riskTaking}</span>
                                <span className={styles.vulner_card_num}>% {props.num}</span>
                            </Grid>
                        </Grid>
                        :
                        <React.Fragment>
                            <div className={styles.vulns_card_cont}>
                                <img className={styles.bug_icon} src={`/assets/icons/${props.icon}.svg`} alt="cardIcon" />
                                <span className={styles.vulner_card_title}>{props.title}</span>
                                <span className={styles.vulner_card_num}>{props.num}</span>
                                <img className={styles.vulns_card_back_img} src={`/assets/icons/${props.icon}.svg`} alt="backImg" />
                            </div>
                        </React.Fragment>
                }

            </React.Fragment>
        </div>
 */
